module.exports = __webpack_public_path__ + "static/media/1_PpGy_yg7uyTzsyTbT5oRhQ.cc3c299d.png";